<template>
  <div class="Experience-Hub">
    <nav class="Experience-Hub__navbar-container" style="background-color: black;">
        <div class="Experience-Hub__navbar Experience-Hub__navbar--centrado">
            <div class="Experience-Hub__navbar-logo">
                <picture>
                    <img class="Experience-Hub__navbar-logo-corporativo" src="https://d2oolfm98c0n60.cloudfront.net/webs-corporativas/pharma/imagenes/img-experienceHub/logo-hub.svg" alt="Logo corporativo de la compañia alebat" title="Logo corportavio de la compañia alebat">
                </picture>
            </div>

            <div class="Experience-Hub__navbar-home">
                <p>Descubre más en <a href="/" target="_blank">pharma.alebateducation.com</a></p>
            </div>
        </div>
    </nav>

    <section class="Experience-Hub__introduccion-container">
        <div class="Experience-Hub__introduccion Experience-Hub__introduccion--centrado">
            <div class="Experience-Hub__introduccion-containerIzq">
                <img v-if="vistaPc" class="Experience-Hub__introduccion-containerIzq-img" src="https://d2oolfm98c0n60.cloudfront.net/webs-corporativas/pharma/imagenes/img-experienceHub/Recurso%2011.png" alt="" title="">
                <img v-if="vistaMovil" class="Experience-Hub__introduccion-containerIzq-img" src="https://d2oolfm98c0n60.cloudfront.net/webs-corporativas/pharma/imagenes/img-experienceHub/Recurso%2013.png" alt="" title="">
                <img v-if="vistaPc" class="logotipo-laFarmacia" src="https://d2oolfm98c0n60.cloudfront.net/webs-corporativas/pharma/imagenes/img-experienceHub/Recurso%2012.png" alt="" title="">
            </div>

            <div class="Experience-Hub__introduccion-containerDer">
                <p class="Experience-Hub__introduccion-containerDer-descripcion">
                    La mejora de la Experiencia de Paciente es clave para el futuro de nuestra salud. Por eso te
                    invitamos a acompañarnos el <span class="texto-destacado">próximo 17 de Noviembre de 18:00 a 20:30h en la </span>
                    <span class="texto-destacado--morado">Tasca la Farmacia</span> (Diego de León, 9, Madrid). Queremos presentarte
                    nuestro <span class="texto-destacado"> Decálogo de Experiencia de Paciente</span> para que aportes tu punto de vista y 
                    podamos, entre todos poner las bases de la excelencia del cuidado de nuestra salud. 
                    <span class="texto-destacado">Tu aportación es clave para nosotros</span>
                </p>

                <p class="Experience-Hub__introduccion-containerDer-descripcion">
                    Y terminaremos la tarde tomando algo. ¡A eso invitamos nosotros!
                </p>

                <p class="Experience-Hub__introduccion-containerDer-descripcion">
                    Te esperamos
                </p>
            </div>
        </div>
    </section>

    <section class="Experience-Hub__formulario-container">
        <div class="Experience-Hub__formulario Experience-Hub__formulario--centrado">
            <div class="Experience-Hub__formulario-titular">
                <span>
                    Registra <br> tu asistencia
                    <img src="https://d2oolfm98c0n60.cloudfront.net/webs-corporativas/pharma/imagenes/img-experienceHub/arrow.svg" alt="" title="">
                </span>
            </div>

            <div class="Experience-Hub__formulario-campos">
                <!-- Change or deletion of the name attributes in the input tag will lead to empty values on record submission-->
                <form action='https://forms.zohopublic.com/alebateducation/form/pharmaasistencia/formperma/-M68Kgpdl-VZibY_1CqR4Kbn4C6c10epv-NqK6hvv3Y/htmlRecords/submit' name='form' id='form' method='POST' accept-charset='UTF-8' enctype='multipart/form-data'>
                    <input type="hidden" name="zf_referrer_name" value=""><!-- To Track referrals , place the referrer name within the " " in the above hidden input field -->
                    <input type="hidden" name="zf_redirect_url" value=""><!-- To redirect to a specific page after record submission , place the respective url within the " " in the above hidden input field -->
                    <input type="hidden" name="zc_gad" value=""><!-- If GCLID is enabled in Zoho CRM Integration, click details of AdWords Ads will be pushed to Zoho CRM -->
                    <!--Single Line-->
                    <div class="Experience-Hub__formulario-campos contenedor-form">
                        <div class="contenedor-form__element">
                            <label> 
                            Nombre 
                            </label>
                            <input required type="text" name="SingleLine" value="" fieldType=1 maxlength="255" placeholder="" />
                        </div>
                        
                        <!--Single Line-->
                        <div class="contenedor-form__element">
                            <label> 
                            Apellidos 
                            </label>
                            <input required type="text" name="SingleLine1" value="" fieldType=1 maxlength="255" placeholder="" />
                        </div>
                        
                        <!--Single Line-->
                        <div class="contenedor-form__element">
                            <label> 
                                Empresa 
                            </label>
                            <input  type="text" name="SingleLine2" value="" fieldType=1 maxlength="255" placeholder="" />
                        </div>
                       
                        <!--Single Line-->
                        <div class="contenedor-form__element">
                            <label> 
                                Cargo 
                            </label>
                            <input  type="text" name="SingleLine3" value="" fieldType=1 maxlength="255" placeholder="" />
                        </div>
                        
                        <!--Single Line-->
                        <div class="contenedor-form__element contenedor-form__element--prefijo">
                            <div style="width:100%">
                                <label> 
                                    Email 
                                </label>
                                <input  required type="text" name="SingleLine4" value="" fieldType=1 maxlength="255" placeholder="" />
                            </div>
                            <!--Single Line-->
                            <div>
                                <label> 
                                    Prefijo 
                                </label>
                                <select
                                    name="SingleLine5"
                                    >
                                    <option value="" disabled>País *</option>
                                    <option data-country="GB" value="44">UK (+44)</option>
                                    <option data-country="US" value="1" selected>USA (+1)</option>
                                    <option data-country="Algeria" value="213">Algeria (+213)</option>
                                    <option data-country="Andorra" value="376">Andorra (+376)</option>
                                    <option data-country="Angola" value="244">Angola (+244)</option>
                                    <option data-country="Anguilla" value="1264">
                                        Anguilla (+1264)
                                    </option>
                                    <option data-country="Antigua" value="1268">
                                        Antigua &amp; Barbuda (+1268)
                                    </option>
                                    <option data-country="Argentina" value="54">
                                        Argentina (+54)
                                    </option>
                                    <option data-country="Armenia" value="374">Armenia (+374)</option>
                                    <option data-country="Aruba" value="297">Aruba (+297)</option>
                                    <option data-country="Australia" value="61">
                                        Australia (+61)
                                    </option>
                                    <option data-country="Austria" value="43">Austria (+43)</option>
                                    <option data-country="Azerbaijan" value="994">
                                        Azerbaijan (+994)
                                    </option>
                                    <option data-country="Bahamas" value="1242">
                                        Bahamas (+1242)
                                    </option>
                                    <option data-country="Bahrain" value="973">Bahrain (+973)</option>
                                    <option data-country="Bangladesh" value="880">
                                        Bangladesh (+880)
                                    </option>
                                    <option data-country="Barbados" value="1246">
                                        Barbados (+1246)
                                    </option>
                                    <option data-country="Belarus" value="375">Belarus (+375)</option>
                                    <option data-country="Belgium" value="32">Belgium (+32)</option>
                                    <option data-country="Belize" value="501">Belize (+501)</option>
                                    <option data-country="Benin" value="229">Benin (+229)</option>
                                    <option data-country="Bermuda" value="1441">
                                        Bermuda (+1441)
                                    </option>
                                    <option data-country="Bhutan" value="975">Bhutan (+975)</option>
                                    <option data-country="Bolivia" value="591">Bolivia (+591)</option>
                                    <option data-country="Bosnia Herzegovina" value="387">
                                        Bosnia Herzegovina (+387)
                                    </option>
                                    <option data-country="Botswana" value="267">
                                        Botswana (+267)
                                    </option>
                                    <option data-country="Brazil" value="55">Brazil (+55)</option>
                                    <option data-country="Brunei" value="673">Brunei (+673)</option>
                                    <option data-country="Bulgaria" value="359">
                                        Bulgaria (+359)
                                    </option>
                                    <option data-country="Burkina Faso" value="226">
                                        Burkina Faso (+226)
                                    </option>
                                    <option data-country="Burundi" value="257">Burundi (+257)</option>
                                    <option data-country="Cambodia" value="855">
                                        Cambodia (+855)
                                    </option>
                                    <option data-country="Cameroon" value="237">
                                        Cameroon (+237)
                                    </option>
                                    <option data-country="Canada" value="1">Canada (+1)</option>
                                    <option data-country="Cape Verde Islands" value="238">
                                        Cape Verde Islands (+238)
                                    </option>
                                    <option data-country="Cayman Islands" value="1345">
                                        Cayman Islands (+1345)
                                    </option>
                                    <option data-country="Central African Republic" value="236">
                                        Central African Republic (+236)
                                    </option>
                                    <option data-country="Chile" value="56">Chile (+56)</option>
                                    <option data-country="China" value="86">China (+86)</option>
                                    <option data-country="Colombia" value="57">Colombia (+57)</option>
                                    <option data-country="Comoros" value="269">Comoros (+269)</option>
                                    <option data-country="Congo" value="242">Congo (+242)</option>
                                    <option data-country="Cook Islands" value="682">
                                        Cook Islands (+682)
                                    </option>
                                    <option data-country="Costa Rica" value="506">
                                        Costa Rica (+506)
                                    </option>
                                    <option data-country="Croatia" value="385">Croatia (+385)</option>
                                    <option data-country="Cuba" value="53">Cuba (+53)</option>
                                    <option data-country="Cyprus North" value="90392">
                                        Cyprus North (+90392)
                                    </option>
                                    <option data-country="Cyprus South" value="357">
                                        Cyprus South (+357)
                                    </option>
                                    <option data-country="Czech Republic" value="42">
                                        Czech Republic (+42)
                                    </option>
                                    <option data-country="Denmark" value="45">Denmark (+45)</option>
                                    <option data-country="Djibouti" value="253">
                                        Djibouti (+253)
                                    </option>
                                    <option data-country="Dominica" value="1809">
                                        Dominica (+1809)
                                    </option>
                                    <option data-country="Dominican Republic" value="1809">
                                        Dominican Republic (+1809)
                                    </option>
                                    <option data-country="Ecuador" value="593">Ecuador (+593)</option>
                                    <option data-country="Egypt" value="20">Egypt (+20)</option>
                                    <option data-country="El Salvador" value="503">
                                        El Salvador (+503)
                                    </option>
                                    <option data-country="Equatorial Guinea" value="240">
                                        Equatorial Guinea (+240)
                                    </option>
                                    <option data-country="Eritrea" value="291">Eritrea (+291)</option>
                                    <option data-country="España" value="34" selected>España (+34)</option>
                                    <option data-country="Estonia" value="372">Estonia (+372)</option>
                                    <option data-country="Ethiopia" value="251">
                                        Ethiopia (+251)
                                    </option>
                                    <option data-country="Falkland Islands" value="500">
                                        Falkland Islands (+500)
                                    </option>
                                    <option data-country="Faroe Islands" value="298">
                                        Faroe Islands (+298)
                                    </option>
                                    <option data-country="Fiji" value="679">Fiji (+679)</option>
                                    <option data-country="Finland" value="358">Finland (+358)</option>
                                    <option data-country="France" value="33">France (+33)</option>
                                    <option data-country="French Guiana" value="594">
                                        French Guiana (+594)
                                    </option>
                                    <option data-country="French Polynesia" value="689">
                                        French Polynesia (+689)
                                    </option>
                                    <option data-country="Gabon" value="241">Gabon (+241)</option>
                                    <option data-country="Gambia" value="220">Gambia (+220)</option>
                                    <option data-country="Georgia" value="7880">
                                        Georgia (+7880)
                                    </option>
                                    <option data-country="Germany" value="49">Germany (+49)</option>
                                    <option data-country="Ghana" value="233">Ghana (+233)</option>
                                    <option data-country="Gibraltar" value="350">
                                        Gibraltar (+350)
                                    </option>
                                    <option data-country="Greece" value="30">Greece (+30)</option>
                                    <option data-country="Greenland" value="299">
                                        Greenland (+299)
                                    </option>
                                    <option data-country="Grenada" value="1473">
                                        Grenada (+1473)
                                    </option>
                                    <option data-country="Guadeloupe" value="590">
                                        Guadeloupe (+590)
                                    </option>
                                    <option data-country="Guam" value="671">Guam (+671)</option>
                                    <option data-country="Guatemala" value="502">
                                        Guatemala (+502)
                                    </option>
                                    <option data-country="Guinea" value="224">Guinea (+224)</option>
                                    <option data-country="Guinea - Bissau" value="245">
                                        Guinea - Bissau (+245)
                                    </option>
                                    <option data-country="Guyana" value="592">Guyana (+592)</option>
                                    <option data-country="Haiti" value="509">Haiti (+509)</option>
                                    <option data-country="Honduras" value="504">
                                        Honduras (+504)
                                    </option>
                                    <option data-country="Hong Kong" value="852">
                                        Hong Kong (+852)
                                    </option>
                                    <option data-country="Hungary" value="36">Hungary (+36)</option>
                                    <option data-country="Iceland" value="354">Iceland (+354)</option>
                                    <option data-country="India" value="91">India (+91)</option>
                                    <option data-country="Indonesia" value="62">
                                        Indonesia (+62)
                                    </option>
                                    <option data-country="Iran" value="98">Iran (+98)</option>
                                    <option data-country="Iraq" value="964">Iraq (+964)</option>
                                    <option data-country="Ireland" value="353">Ireland (+353)</option>
                                    <option data-country="Israel" value="972">Israel (+972)</option>
                                    <option data-country="Italy" value="39">Italy (+39)</option>
                                    <option data-country="Jamaica" value="1876">
                                        Jamaica (+1876)
                                    </option>
                                    <option data-country="Japan" value="81">Japan (+81)</option>
                                    <option data-country="Jordan" value="962">Jordan (+962)</option>
                                    <option data-country="Kazakhstan" value="7">
                                        Kazakhstan (+7)
                                    </option>
                                    <option data-country="Kenya" value="254">Kenya (+254)</option>
                                    <option data-country="Kiribati" value="686">
                                        Kiribati (+686)
                                    </option>
                                    <option data-country="Korea North" value="850">
                                        Korea North (+850)
                                    </option>
                                    <option data-country="Korea South" value="82">
                                        Korea South (+82)
                                    </option>
                                    <option data-country="Kuwait" value="965">Kuwait (+965)</option>
                                    <option data-country="Kyrgyzstan" value="996">
                                        Kyrgyzstan (+996)
                                    </option>
                                    <option data-country="Laos" value="856">Laos (+856)</option>
                                    <option data-country="Latvia" value="371">Latvia (+371)</option>
                                    <option data-country="Lebanon" value="961">Lebanon (+961)</option>
                                    <option data-country="Lesotho" value="266">Lesotho (+266)</option>
                                    <option data-country="Liberia" value="231">Liberia (+231)</option>
                                    <option data-country="Libya" value="218">Libya (+218)</option>
                                    <option data-country="Liechtenstein" value="417">
                                        Liechtenstein (+417)
                                    </option>
                                    <option data-country="Lithuania" value="370">
                                        Lithuania (+370)
                                    </option>
                                    <option data-country="Luxembourg" value="352">
                                        Luxembourg (+352)
                                    </option>
                                    <option data-country="Macao" value="853">Macao (+853)</option>
                                    <option data-country="Macedonia" value="389">
                                        Macedonia (+389)
                                    </option>
                                    <option data-country="Madagascar" value="261">
                                        Madagascar (+261)
                                    </option>
                                    <option data-country="Malawi" value="265">Malawi (+265)</option>
                                    <option data-country="Malaysia" value="60">Malaysia (+60)</option>
                                    <option data-country="Maldives" value="960">
                                        Maldives (+960)
                                    </option>
                                    <option data-country="Mali" value="223">Mali (+223)</option>
                                    <option data-country="Malta" value="356">Malta (+356)</option>
                                    <option data-country="Marshall Islands" value="692">
                                        Marshall Islands (+692)
                                    </option>
                                    <option data-country="Martinique" value="596">
                                        Martinique (+596)
                                    </option>
                                    <option data-country="Mauritania" value="222">
                                        Mauritania (+222)
                                    </option>
                                    <option data-country="Mayotte" value="269">Mayotte (+269)</option>
                                    <option data-country="Mexico" value="52">Mexico (+52)</option>
                                    <option data-country="Micronesia" value="691">
                                        Micronesia (+691)
                                    </option>
                                    <option data-country="Moldova" value="373">Moldova (+373)</option>
                                    <option data-country="Monaco" value="377">Monaco (+377)</option>
                                    <option data-country="Mongolia" value="976">
                                        Mongolia (+976)
                                    </option>
                                    <option data-country="Montserrat" value="1664">
                                        Montserrat (+1664)
                                    </option>
                                    <option data-country="Morocco" value="212">Morocco (+212)</option>
                                    <option data-country="Mozambique" value="258">
                                        Mozambique (+258)
                                    </option>
                                    <option data-country="Myanmar" value="95">Myanmar (+95)</option>
                                    <option data-country="Namibia" value="264">Namibia (+264)</option>
                                    <option data-country="Nauru" value="674">Nauru (+674)</option>
                                    <option data-country="Nepal" value="977">Nepal (+977)</option>
                                    <option data-country="Netherlands" value="31">
                                        Netherlands (+31)
                                    </option>
                                    <option data-country="New Caledonia" value="687">
                                        New Caledonia (+687)
                                    </option>
                                    <option data-country="New Zealand" value="64">
                                        New Zealand (+64)
                                    </option>
                                    <option data-country="Nicaragua" value="505">
                                        Nicaragua (+505)
                                    </option>
                                    <option data-country="Niger" value="227">Niger (+227)</option>
                                    <option data-country="Nigeria" value="234">Nigeria (+234)</option>
                                    <option data-country="Niue" value="683">Niue (+683)</option>
                                    <option data-country="Norfolk Islands" value="672">
                                        Norfolk Islands (+672)
                                    </option>
                                    <option data-country="Northern Marianas" value="670">
                                        Northern Marianas (+670)
                                    </option>
                                    <option data-country="Norway" value="47">Norway (+47)</option>
                                    <option data-country="Oman" value="968">Oman (+968)</option>
                                    <option data-country="Palau" value="680">Palau (+680)</option>
                                    <option data-country="Panama" value="507">Panama (+507)</option>
                                    <option data-country="Papua New Guinea" value="675">
                                        Papua New Guinea (+675)
                                    </option>
                                    <option data-country="Paraguay" value="595">
                                        Paraguay (+595)
                                    </option>
                                    <option data-country="Peru" value="51">Peru (+51)</option>
                                    <option data-country="Philippines" value="63">
                                        Philippines (+63)
                                    </option>
                                    <option data-country="Poland" value="48">Poland (+48)</option>
                                    <option data-country="Portugal" value="351">
                                        Portugal (+351)
                                    </option>
                                    <option data-country="Puerto Rico" value="1787">
                                        Puerto Rico (+1787)
                                    </option>
                                    <option data-country="Qatar" value="974">Qatar (+974)</option>
                                    <option data-country="Reunion" value="262">Reunion (+262)</option>
                                    <option data-country="Romania" value="40">Romania (+40)</option>
                                    <option data-country="Russia" value="7">Russia (+7)</option>
                                    <option data-country="Rwanda" value="250">Rwanda (+250)</option>
                                    <option data-country="San Marino" value="378">
                                        San Marino (+378)
                                    </option>
                                    <option data-country="ST" value="239">
                                        Sao Tome &amp; Principe (+239)
                                    </option>
                                    <option data-country="Saudi Arabia" value="966">
                                        Saudi Arabia (+966)
                                    </option>
                                    <option data-country="Senegal" value="221">Senegal (+221)</option>
                                    <option data-country="Serbia" value="381">Serbia (+381)</option>
                                    <option data-country="Seychelles" value="248">
                                        Seychelles (+248)
                                    </option>
                                    <option data-country="Sierra Leone " value="232">
                                        Sierra Leone (+232)
                                    </option>
                                    <option data-country="Singapore" value="65">
                                        Singapore (+65)
                                    </option>
                                    <option data-country="Slovak Republic" value="421">
                                        Slovak Republic (+421)
                                    </option>
                                    <option data-country="Slovenia" value="386">
                                        Slovenia (+386)
                                    </option>
                                    <option data-country="Solomon Islands" value="677">
                                        Solomon Islands (+677)
                                    </option>
                                    <option data-country="Somalia" value="252">Somalia (+252)</option>
                                    <option data-country="South Africa" value="27">
                                        South Africa (+27)
                                    </option>
                                    <option data-country="Sri Lanka " value="94">
                                        Sri Lanka (+94)
                                    </option>
                                    <option data-country="St. Helena" value="290">
                                        St. Helena (+290)
                                    </option>
                                    <option data-country="St. Kitts" value="1869">
                                        St. Kitts (+1869)
                                    </option>
                                    <option data-country="St. Lucia" value="1758">
                                        St. Lucia (+1758)
                                    </option>
                                    <option data-country="Sudan" value="249">Sudan (+249)</option>
                                    <option data-country="Suriname" value="597">
                                        Suriname (+597)
                                    </option>
                                    <option data-country="Swaziland" value="268">
                                        Swaziland (+268)
                                    </option>
                                    <option data-country="Sweden" value="46">Sweden (+46)</option>
                                    <option data-country="Switzerland" value="41">
                                        Switzerland (+41)
                                    </option>
                                    <option data-country="Syria" value="963">Syria (+963)</option>
                                    <option data-country="Taiwan" value="886">Taiwan (+886)</option>
                                    <option data-country="Tajikstan" value="7">Tajikstan (+7)</option>
                                    <option data-country="Thailand" value="66">Thailand (+66)</option>
                                    <option data-country="Togo" value="228">Togo (+228)</option>
                                    <option data-country="Tonga" value="676">Tonga (+676)</option>
                                    <option data-country="Trinidad" value="1868">
                                        Trinidad &amp; Tobago (+1868)
                                    </option>
                                    <option data-country="Tunisia" value="216">Tunisia (+216)</option>
                                    <option data-country="Turkey" value="90">Turkey (+90)</option>
                                    <option data-country="Turkmenistan" value="7">
                                        Turkmenistan (+7)
                                    </option>
                                    <option data-country="Turkmenistan" value="993">
                                        Turkmenistan (+993)
                                    </option>
                                    <option data-country="Turks" value="1649">
                                        Turks &amp; Caicos Islands (+1649)
                                    </option>
                                    <option data-country="Tuvalu" value="688">Tuvalu (+688)</option>
                                    <option data-country="Uganda" value="256">Uganda (+256)</option>
                                    <option data-country="Ukraine" value="380">Ukraine (+380)</option>
                                    <option data-country="United Arab Emirates" value="971">
                                        United Arab Emirates (+971)
                                    </option>
                                    <option data-country="Uruguay" value="598">Uruguay (+598)</option>
                                    <option data-country="Uzbekistan" value="7">
                                        Uzbekistan (+7)
                                    </option>
                                    <option data-country="Vanuatu" value="678">Vanuatu (+678)</option>
                                    <option data-country="Vatican City" value="379">
                                        Vatican City (+379)
                                    </option>
                                    <option data-country="Venezuela" value="58">
                                        Venezuela (+58)
                                    </option>
                                    <option data-country="Vietnam" value="84">Vietnam (+84)</option>
                                    <option data-country="Virgin Islands - British" value="84">
                                        Virgin Islands - British (+1284)
                                    </option>
                                    <option data-country="Virgin Islands - US" value="84">
                                        Virgin Islands - US (+1340)
                                    </option>
                                    <option data-country="Wallis" value="681">
                                        Wallis &amp; Futuna (+681)
                                    </option>
                                    <option data-country="Yemen (North)" value="969">
                                        Yemen (North)(+969)
                                    </option>
                                    <option data-country="Yemen (South)" value="967">
                                        Yemen (South)(+967)
                                    </option>
                                    <option data-country="Zambia" value="260">Zambia (+260)</option>
                                    <option data-country="Zimbabwe" value="263">
                                        Zimbabwe (+263)
                                    </option>
                                </select>
                            </div>
                            
                        </div>
                        
                        <!--Single Line-->
                        <div class="contenedor-form__element">
                            <label> 
                                Teléfono 
                            </label>
                            <input required type="text" name="SingleLine6" value="" fieldType=1 maxlength="255" placeholder="" />
                        </div>

                        <!--Decision Box-->
                        <div class="contenedor-form__element contenedor-form__element--politica">
                            <input type="checkbox" id="DecisionBox" required name="DecisionBox"/>
                            <label for="DecisionBox">He leído y acepto la <a href="/politica-de-privacidad" target="_blank">Politica de privacidad</a></label>
                        </div>
                        
                        <button class="contenedor-form__submit" type="submit"><em>ENVIAR</em></button>
                        
                    </div>
                    
                </form>
            </div>
        </div>
    </section>

    <footer class="Experience-Hub__footer-container">
        <div class="Experience-Hub__footer Experience-Hub__footer--centrado">
            <div class="Experience-Hub__footer-logoPartner">
                <p>Organizan</p>
                <div>
                    <img class="Experience-Hub__footer-logoPartner-img" src="https://d2oolfm98c0n60.cloudfront.net/webs-corporativas/pharma/imagenes/img-experienceHub/cobranding.svg" alt="Logotipo corporativo de la compañia alebat" title="Logotipo corporativo de la compañia alebat">
                </div>
                
            </div>

            <div class="Experience-Hub__footer-logo">
                <p>Powered by</p>
                <img class="Experience-Hub__footer-logo-img" src="https://d2oolfm98c0n60.cloudfront.net/webs-corporativas/pharma/imagenes/img-experienceHub/logo-alebat.svg" alt="Logotipo corporativo de la compañia alebat" title="Logotipo corporativo de la compañia alebat">
            </div>
        </div>
    </footer>
  </div>
  <CustomCursor />
</template>

<script>
import CustomCursor from "@/components/customCursor/CustomCursor.vue";

export default {
    name: 'ExperienceHub',
    components:{
        CustomCursor
    },
    data: () =>{
        return{
            vistaPc: window.innerWidth > 1023,
            vistaMovil: window.innerWidth <= 1023,
        }
    },
    methods:{
        cambioDeVista(){
            var tamanio = window.innerWidth;
            this.vistaPc = tamanio > 1023;
            this.vistaMovil = tamanio <= 1023;
        }
    },
    created() {
        window.addEventListener('resize',this.cambioDeVista)
    }
}
</script>